import { createFeatureSelector, createSelector } from '@ngrx/store';
import { authFeatureKey, AuthState } from '@app2/store/auth/auth.reducer';

const selectState = createFeatureSelector<AuthState>(authFeatureKey);

const selectIsLoading = createSelector(selectState, (state) => state.isLoading);
const selectErrors = createSelector(selectState, (state) => state.errors);
const selectStep = createSelector(selectState, (state) => state.step);

export const authSelectors = {
  selectIsLoading,
  selectErrors,
  selectStep,
};
